module.exports = __webpack_public_path__ + "static/media/unselectedTick.3be204ad.png";